'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'books-medical';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f7e8';
var svgPathData = 'M79.1 352h31.1c8.836 0 16-7.164 16-16L127.1 288h47.1c8.836 0 16-7.165 16-16v-32c0-8.836-7.165-15.1-16-15.1H127.1l.0006-47.1c0-8.836-7.165-15.1-16-15.1H79.1c-8.836 0-15.1 7.163-15.1 15.1L63.1 224H16c-8.836 0-16 7.163-16 15.1v32c0 8.836 7.164 16 16 16h47.1L63.1 336C63.1 344.8 71.16 352 79.1 352zM574.4 435.4l-107.7-399.9C460.9 14.08 441.5 0 420.4 0c-4.111 0-8.294 .5313-12.46 1.641l-61.82 16.48c-5.885 1.57-11.14 4.258-15.78 7.633C322.3 10.51 306.4 0 288 0H224C215.2 0 207.1 2.531 200 6.656C192.9 2.531 184.8 0 176 0h-64C85.49 0 64 21.49 64 48v56C64 117.3 74.75 128 88 128S112 117.3 112 104V48h64v120C176 181.3 186.7 192 200 192S224 181.3 224 168V144h64v224H224v-24C224 330.7 213.3 320 200 320S176 330.7 176 344v120h-64v-56C112 394.7 101.3 384 88 384S64 394.7 64 408v56C64 490.5 85.49 512 112 512h64c8.787 0 16.92-2.531 24-6.656C207.1 509.5 215.2 512 224 512h64c26.51 0 48-21.49 48-48V165.3l83.8 311.3C425.6 497.9 444.9 512 466.1 512c4.111 0 8.293-.5313 12.46-1.641l61.91-16.51C565.1 487.1 581.2 460.8 574.4 435.4zM288 464H224L224 416H288V464zM288 96H224L224 48h64V96zM358.4 64.5l61.83-16.48l12.47 45.91L370.8 110.4L358.4 64.5zM383.3 156.6l61.91-16.51l58.04 215.3l-61.91 16.51L383.3 156.6zM466.2 464.1l-12.41-46.04l61.91-16.51l12.38 45.94L466.2 464.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBooksMedical = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;